import cn from 'classnames'
import { TStatusDefaultProps } from './status.default.d'
import './status.default.scss'

export const Default = ({ className, children }: TStatusDefaultProps) => (
  <div className={cn('status-default', className)}>{children}</div>
)
